import { Tab } from '../../../components/shared/tabs';
import {
  MessageType,
  msgBy,
  msgFrom,
  msgOpJoinSpace,
  msgTo,
} from '../../../core/localization';
import { areEqual as areEqualDevices, PKey as DeviceKey } from '../../devices';
import { areEqualILog, AreEqualILog } from '../../historical';
import { TransferActivitiesTabNames, TransferActivityTabs, TransferStatus, TransferType } from './consts';
import {
  Activity,
  Transfer,
} from './model';

export const activityTabsData: Tab[] = [
  { id: TransferActivityTabs.OPEN, label: TransferActivitiesTabNames.OPEN },
  { id: TransferActivityTabs.CLOSED, label: TransferActivitiesTabNames.CLOSED },
];

export const getLogSubtitle = (tx: Activity, isSender: boolean) => {
  let msg: MessageType = '';
  if (tx.type === TransferType.SEND) {
    if (tx.status === TransferStatus.COMPLETED)
      msg = isSender ? msgTo(tx.toCustomerName) : msgFrom(tx.fromCustomerName);
  } else {
    switch (tx.status) {
      case TransferStatus.PENDING:
        msg = isSender
          ? msgFrom(tx.toUserName, tx.toCustomerName)
          : msgBy(tx.toUserName);
        break;
      case TransferStatus.COMPLETED:
        msg = isSender
          ? msgOpJoinSpace('requested', msgFrom(tx.toCustomerName))
          : msgOpJoinSpace('requested', msgTo(tx.fromCustomerName));
        break;

      case TransferStatus.REJECTED:
        msg = isSender ? msgFrom(tx.toCustomerName) : msgBy(tx.toUserName);
        break;
      case TransferStatus.CANCELLED:
        msg = isSender
          ? msgFrom(tx.toCustomerName)
          : msgBy(tx.toUserName, `cancelled by ${tx.fromUserName}`);
        break;
      case TransferStatus.DISCARTED:
        msg = isSender
          ? `from ${tx.toCustomerName}`
          : msgBy(
              tx.toUserName,
              `cancelled by the system. It is no longer valid`
            );
        break;
      default:
        break;
    }
  }
  return msg;
};

export const isSender = (a: Activity, customerName: string) =>
  a.fromCustomerName === customerName;

export const isClosedTx = (status: TransferStatus) =>
  status === TransferStatus.COMPLETED ||
  status === TransferStatus.REJECTED ||
  status === TransferStatus.CANCELLED ||
  status === TransferStatus.DISCARTED;

export const areEqual: AreEqualILog<Activity> = (a, b) =>
  areEqualILog(a, b) && a.id === b.id;

export const hasDevice = (tx: Transfer, id: DeviceKey) =>
  tx.devices?.some((d) => areEqualDevices(id, d));

// Transfer Actions
export const addDeviceToTx = (tx: Transfer, d: DeviceKey): Transfer => ({
  ...tx,
  devices: [...tx.devices, d],
});

export const clearDeviceFromTx = (tx: Transfer, d: DeviceKey): Transfer => ({
  ...tx,
  devices: tx.devices.filter((txd) => !areEqualDevices(txd, d)),
});

export const changeTxStatus = (
  tx: Transfer,
  status: TransferStatus
): Transfer => ({
  ...tx,
  status,
});

export const setTxId = (tx: Transfer, id: number): Transfer => ({ ...tx, id });

export const validateTx = (tx: Transfer): Transfer => ({
  ...tx,
  status: TransferStatus.VALIDATED,
});
